import styled from "styled-components"
import {
  Descripition,
  Headline,
  StyledGradientTitle,
  animationProperties,
} from "../../../utils"
import { ContactForm } from "../ContactForm"
import { AosWrapper } from "../../molecules/AosWrapper"

const Wrapper = styled.div`
  padding: 80px 20px 80px 20px;
  background-color: ${(props) => props.theme.footerSectionColor};
  @media (max-width: 1350px) {
    padding: 80px 0px;
  }
  @media (max-width: 915px) {
    padding: 80px 0px;
  }
  @media (max-width: 641px) {
    padding: 50px 20px;
  }
  @media (max-width: 374px) {
    padding: 50px 20px;
  }
`

const ContactFormSection = () => {
  return (
    <Wrapper id={"contact"}>
      <AosWrapper>
        <Headline>
          <StyledGradientTitle id="contact-us-form">
            {"Connect "}
          </StyledGradientTitle>
          {"with us effortlessly "}
        </Headline>
        <Descripition>
          {"Simply fill out our contact form and we'll take care of the rest!"}
        </Descripition>
        <AosWrapper
          duration={animationProperties.duration + 0.2}
          delay={animationProperties.delay + 0.2}
          animateIn={"animate__fadeInUpBig animate__zoomIn"}
        >
          <ContactForm />
        </AosWrapper>
      </AosWrapper>
    </Wrapper>
  )
}

export { ContactFormSection }
